import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

const Pluralize = ({ word, count, showCount = true }) => (
  <>
    {showCount && count} {pluralize(word, parseInt(count, 10))}
  </>
);

Pluralize.propTypes = {
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  word: PropTypes.string.isRequired,
  showCount: PropTypes.bool
};

export { Pluralize };
